__turbopack_context__.v({
  "actionBtn": "notifications-module__qLAecG__actionBtn",
  "badge": "notifications-module__qLAecG__badge",
  "container": "notifications-module__qLAecG__container",
  "emptyState": "notifications-module__qLAecG__emptyState",
  "header": "notifications-module__qLAecG__header",
  "markAllBtn": "notifications-module__qLAecG__markAllBtn",
  "notificationActions": "notifications-module__qLAecG__notificationActions",
  "notificationContent": "notifications-module__qLAecG__notificationContent",
  "notificationHeader": "notifications-module__qLAecG__notificationHeader",
  "notificationIcon": "notifications-module__qLAecG__notificationIcon",
  "notificationItem": "notifications-module__qLAecG__notificationItem",
  "notificationMessage": "notifications-module__qLAecG__notificationMessage",
  "notificationTime": "notifications-module__qLAecG__notificationTime",
  "notificationTitle": "notifications-module__qLAecG__notificationTitle",
  "notificationsList": "notifications-module__qLAecG__notificationsList",
  "read": "notifications-module__qLAecG__read",
  "subtitle": "notifications-module__qLAecG__subtitle",
  "title": "notifications-module__qLAecG__title",
  "unreadDot": "notifications-module__qLAecG__unreadDot",
});
